export default {
    NON_REFUNDABLE: 'nonRefundable',
    FULLY_REFUNDABLE: 'fullyRefundable',
    PARTIALLY_REFUNDABLE: 'partiallyRefundable',
};
